import { Injectable } from '@angular/core';
import { IEntity } from 'interfaces-lib';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FileListControllerService {
  private subject = new Subject<IEntity | null>();
  refresh$ = this.subject.asObservable();

  refresh(entity: IEntity): void {
    this.subject.next(entity);
  }
}
